import Grid from "@mui/material/Grid";
import { AccessKeys } from "app/appConstants";
import { HeaderPublisher } from "layouts/common/outside/HeaderPublisher";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { RootPaths } from "routes/RootRouter";
import { HeaderSearch } from "views/general/GlobalSearch/HeaderSearch";
import { AppLogo } from "views/public/app/AppLogo";
import { HeaderAward } from "./HeaderAward";
import { HeaderNotifications } from "./HeaderNotifications";
import { HeaderUserMenu } from "./HeaderUserMenu";

/////////////////////////////////////////////////////////////////////////////////////////////////

export const Header: React.FC = () => {

    const { t } = useTranslation("shared");

    return (
        <Grid container alignItems="center" justifyContent="center" width="100%">
            <Grid>
                <Link to={RootPaths.Home} title={t("App.Menu.Topbar.GoHomeTitle")} accessKey={AccessKeys.FeedStartup}>
                    <AppLogo />
                </Link>
            </Grid>
            <Grid size="grow">
                <HeaderSearch />
            </Grid>
            <Grid>
                <HeaderPublisher />
            </Grid>
            <Grid>
                <HeaderAward />
            </Grid>
            <Grid>
                <HeaderNotifications />
            </Grid>
            <Grid>
                <HeaderUserMenu />
            </Grid>
        </Grid>
    );
};
